import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { getLocalStorage } from '@zola-helpers/client';

// selectors
import { getUserContext } from 'selectors/user/userSelectors';

// virtual event tour
import {
  localStorageKey,
  STEPS,
} from './WalkthroughTour/StepCollections/VirtualEventsOnboardingEditPage';
import WalkthroughTour from './WalkthroughTour/WalkthroughTour';

// Actions
import { activatePage } from '../../../actions/website/PageActions';

// Utils
import { EDIT_PAGE_COMPONENTS } from './util/constants';
import isVirtualEvents from '../VirtualEvents/util/isVirtualEvents';

const EditPage = ({ pageKey, page, activateCmsPage, theme, userContext }) => {
  const pageType = page ? page.type : undefined;
  const CurrentPage = pageType ? EDIT_PAGE_COMPONENTS[pageType].page : undefined;
  const CurrentPreview = pageType ? EDIT_PAGE_COMPONENTS[pageType].preview : undefined;
  const themeKey = theme.key || undefined;
  const themeFont = theme.font_name || undefined;
  const isDev =
    window.location.hostname === 'localhost' || window.location.hostname === 'qa.zola.com';
  const cloudfront = isDev
    ? 'https://d2wzwlp3rxwsn1.cloudfront.net'
    : 'https://d2gt2lt628wbyx.cloudfront.net';

  const virtualEvents = isVirtualEvents(userContext);

  useEffect(() => {
    if (pageKey) activateCmsPage(pageKey);
  }, [pageKey, page]);

  // walkthrough tour
  const isTourDisabled = getLocalStorage(localStorageKey) === 'true';
  const showVirtualEventTour = virtualEvents && pageType === 'EVENT' && !isTourDisabled;

  return (
    <Fragment>
      {themeKey && (
        <Helmet
          link={[
            {
              rel: 'stylesheet',
              href: `https://fonts.googleapis.com/css?family=${themeFont}`,
            },
            {
              rel: 'stylesheet',
              href: `${cloudfront}/${themeKey}.css`,
            },
          ]}
        />
      )}
      {page && (
        <Fragment>
          {!CurrentPreview ? (
            <CurrentPage page={page} pageType={pageType} themeKey={themeKey} />
          ) : (
            <div className="container-fluid">
              <div className="row">
                <div className="column col-xs-12 col-md-5">
                  <CurrentPage useDragHandle lockAxis="y" />
                </div>
                <div className="column col-md-7 hidden-sm hidden-xs">
                  <CurrentPreview pageType={pageType} />
                </div>
              </div>
            </div>
          )}
        </Fragment>
      )}
      {showVirtualEventTour && (
        <WalkthroughTour steps={STEPS} localStorageKey={localStorageKey} desktopOnly />
      )}
    </Fragment>
  );
};

EditPage.propTypes = {
  page: PropTypes.shape({}),
  activateCmsPage: PropTypes.func.isRequired,
  pageKey: PropTypes.string,
  theme: PropTypes.shape({ key: PropTypes.string, font_name: PropTypes.string }),
};

const mapStateToProps = (state, ownProps) => {
  const { byId, typeToId, orderedIds } = state.website.pages;
  const pageKey = ownProps.params.pageKey ? ownProps.params.pageKey.toUpperCase() : undefined;
  const pageId = pageKey ? typeToId[pageKey] : undefined;
  const page = pageId ? byId[pageId] : byId[orderedIds[0]];

  return {
    pageKey,
    page,
    theme: state.wedding.theme,
    userContext: getUserContext(state),
  };
};

const mapDispatchToProps = dispatch => ({
  activateCmsPage: pageKey => dispatch(activatePage(pageKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPage);



// WEBPACK FOOTER //
// ./src/components/manage/website/EditPage.jsx